import { SubCapabilityKey } from "@next-platform/packages-ts-types";
import { useCallback } from "react";
import { useApplicationCapabilitiesAllowed } from "../../../infra/application/capabilities";
import usePersona from "../../user/userPersona/usePersona";
import useConversationRulebookSettings from "../useConversationRulebookSettings";
import useResolvedRulebook from "../useResolvedRulebook";
/**
 * Whether this chat's meter panel is hidden, whether the hide/show control applies, and the toggle. Hiding keeps
 * evaluation running; the control is the way back once the meters are hidden.
 */
export default function useRulebookHudVisibility({ characterId, conversationId, isAvailable }) {
    const isHudAllowed = useApplicationCapabilitiesAllowed(SubCapabilityKey.RulebookChatHud);
    const { selectedPersona } = usePersona();
    const { rulebook } = useResolvedRulebook({ characterId, conversationId, personaId: selectedPersona?.id });
    const { settings, setHudHidden } = useConversationRulebookSettings({ conversationId });
    const isHidden = settings.hud_hidden === true;
    const isShown = isAvailable && isHudAllowed && Boolean(conversationId) && Boolean(rulebook);
    const toggle = useCallback(() => setHudHidden(!isHidden), [setHudHidden, isHidden]);
    return { isHidden, isShown, toggle };
}
